import React, {useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import feather from 'feather-icons';
import Home from "./pages/home";
import About from "./pages/about";
import Contact from "./pages/contact";
import Login from "./pages/login";
import Register from "./pages/register";
import Faq from "./pages/faq";
import Products from "./pages/products";
import Shop from "./pages/shop"; 
import Checkout from "./pages/checkouts"; 
import SingleProduct from "./pages/singleProduct"; 
import Cart from "./pages/cart"; 
import Address from "./pages/address"; 
import Whishlist from "./pages/wishlist"; 
import CustomizableProducts from "./pages/customizableproducts";
import Accounts from "./pages/accounts";
import PrivacyPolicy from "./pages/privacypolicy";
import TermsAndConditions from "./pages/termscondition";
import Return from "./pages/return";
import Shipping from "./pages/shipping";
import Track from "./pages/track";
import Payment from "./pages/payment";
import Paymentstatus from "./pages/paymentStatus";
import ProductPage from "./pages/select";
import Search from "./pages/search";


const App = () => {

   useEffect(() => {
          feather.replace();
      }, []); 
      
  return (
    
    <Router>      
      
      <Routes>
         
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products/>}/>
        <Route path="/about" element={<About/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/register" element={<Register/>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="/singleproduct" element={<SingleProduct/>}/>
         <Route path="/cart" element={<Cart/>}/>
        <Route path="/faq" element={<Faq/>}/>    
        <Route path="/checkout" element={<Checkout/>}/>    
        <Route path="/shop" element={<Shop/>}/>    
        <Route path="/addaddress" element={<Address/>}/>    
        <Route path="/wishlist" element={<Whishlist/>}/>  
        <Route path="/customizableproducts" element={<CustomizableProducts/>}/>  
        <Route path="/accounts"  element={<Accounts/>}/>
        <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
        <Route path="/termscondition" element={<TermsAndConditions/>}/>
        <Route path="/returnpolicy" element={<Return/>}/>
        <Route path="/shipping" element={<Shipping/>}/>
        <Route path="/track" element={<Track/>}/>
        <Route path="/payment" element={<Payment/>}/>
        <Route path="/payment-status" element={<Paymentstatus/>}/>
        <Route path="/test" element={<ProductPage/>}/>
        <Route path="/search" element={<Search/>}/>
        
      </Routes>

    </Router>
    
  );
};

export default App;
